import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Badge } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { sendSalaryAcknowledgment } from "../services/salaryServices";
import toast from "react-hot-toast";
import Loader from "./Loader";
import { companyID } from "../auth";

const SalaryAcknowledgementModal = ({ show, handleClose, salaryData }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const employee_id = localStorage.getItem("employeeID");
  const [loader, setLoader] = useState({
    show: false,
    message: "",
  });
  const companyId = companyID();

  const getFormattedDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  };

  useEffect(() => {
    const selectedMonthYear = getFormattedDate(selectedDate);
    const filtered = salaryData.filter(
      (emp) => emp.month === selectedMonthYear && emp.salary_status === 0
    );
    setFilteredEmployees(filtered);
    setSelectedEmployees([]);
  }, [selectedDate, salaryData]);

  const employeeOptions = filteredEmployees.map((emp) => ({
    value: emp.employee_id,
    label: `${emp.first_name} ${emp.last_name}`,
  }));

  const handleSelectionChange = (selectedOptions) => {
    if (
      selectedOptions &&
      selectedOptions.some((option) => option.value === "select_all")
    ) {
      if (selectedEmployees.length === filteredEmployees.length) {
        setSelectedEmployees([]);
      } else {
        setSelectedEmployees(employeeOptions);
      }
    } else {
      setSelectedEmployees(selectedOptions || []);
    }
  };

  const resetData = () => {
    setFilteredEmployees([]);
    setSelectedEmployees([]);
    setSelectedDate(new Date());
  };

  useEffect(() => {
    resetData();
  }, []);

  const sendAcknowledgment = async () => {
    handleClose();
    resetData();
    const acknowledgmentData = {
      employees: selectedEmployees,
      yearMonth: getFormattedDate(selectedDate),
      notify_by: employee_id,
      companyId: companyId,
    };
    setLoader({
      show: true,
      message: "Sending salary acknowledgment to employees...",
    });

    try {
      const result = await sendSalaryAcknowledgment(acknowledgmentData);
      toast.success(result);
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
      console.error(error);
    } finally {
      setLoader({ show: false, message: "" });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Salary Acknowledgment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Select Month & Year</Form.Label>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="yyyy-MM"
              showMonthYearPicker
              className="form-control"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Select Employees</Form.Label>
            {filteredEmployees.length === 0 ? (
              <p className="text-muted">
                No employees pending salary acknowledgment.
              </p>
            ) : (
              <Select
                isMulti
                options={[
                  {
                    value: "select_all",
                    label:
                      selectedEmployees.length === filteredEmployees.length
                        ? "Deselect All"
                        : "Select All",
                  },
                  ...employeeOptions,
                ]}
                value={selectedEmployees}
                onChange={handleSelectionChange}
                placeholder="Select employees..."
                isClearable
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
              />
            )}

            <div className="mt-2">
              {selectedEmployees.map(
                (emp) =>
                  emp.value !== "select_all" && (
                    <Badge key={emp.value} pill bg="primary" className="me-2">
                      {emp.label}
                    </Badge>
                  )
              )}
            </div>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              resetData();
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={selectedEmployees.length === 0}
            onClick={sendAcknowledgment}
          >
            <i
              class="fa-solid fa-paper-plane"
              title="Send salary credited acknowledgment to employees"
            />{" "}
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      {loader.show && (
        <Loader show={loader.show} loadingMessage={loader.message} />
      )}
    </>
  );
};

export default SalaryAcknowledgementModal;
